import { LocationResponseModel } from "@/models/location";
import React, { createContext, useState, useContext } from "react";

export interface StateData {
  isLoading?: boolean;
  isHiddenLocation: boolean;
  locationSelected?: LocationResponseModel | null;
  locationKey: string;
}

export interface StateLocationContextType {
  data: StateData;
  setData: React.Dispatch<React.SetStateAction<StateData>>;
  reloadData: (loadFisrt?: boolean) => void;
}

const LocationContext = createContext<StateLocationContextType | undefined>(undefined);

export const useLocationContext = () => {
  const context = useContext(LocationContext);
  
  if (!context) {
    throw new Error("useLocationContext must be used within a LocationProvider");
  }
  return context;
};

export default LocationContext;